import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HostnamePublicModelPostRequest } from '../../../../../../models/aggregates/custom/platform';
import { HostnameContainerModel } from '../../../../../../models/aggregates/hostname';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from '../../shared';




@Injectable({
  providedIn: 'root'
})
export class HostNamePublicService extends BaseApiTemplateService<HostnamePublicModelPostRequest> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames-public';
    this.httpClient = http;
  }

  postToPublicHostname(hostnamePublicModelPostRequest: HostnamePublicModelPostRequest, visa: ApiVisa) {
    let url = '';

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post(url, hostnamePublicModelPostRequest);
  }

  getByHostname(hostname: string, apiVisa: ApiVisa): Observable<BasicApiResponseModel<HostnameContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + `/${hostname}`;
    return this.httpClient.get<BasicApiResponseModel<HostnameContainerModel>>(url, this.getHttpHeader(apiVisa));
  }

}
